var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.16 58.47a.98.98 0 0 0 .03 1.11c.19.27.5.43.82.43.07 0 .14 0 .22-.02l9.19-2.04c2.65 1.35 5.62 2.06 8.6 2.06 10.37 0 18.82-8.36 18.98-18.7 4.5 1.22 9.43.76 13.61-1.36l9.19 2.03c.07.02.14.02.22.02.32 0 .63-.16.82-.43.23-.33.24-.77.03-1.11l-3.75-5.93a19.01 19.01 0 0 0 3.9-11.54c0-10.48-8.52-19-19-19S25.2 12.35 25.04 22.68c-1.6-.44-3.28-.69-5.02-.69C9.52 22 1 30.52 1 41c0 4.17 1.38 8.24 3.91 11.54zM44 6c9.37 0 17 7.63 17 17 0 3.95-1.38 7.8-3.9 10.83-.28.33-.31.81-.08 1.17l2.85 4.5-7.2-1.59c-.23-.05-.48-.02-.69.09-3.99 2.12-8.8 2.53-13.08 1.19-.68-7.21-5.42-13.26-11.9-15.84 0-.12-.01-.24-.01-.36 0-9.37 7.63-17 17-17zM3 41c0-9.37 7.63-17 17-17s17 7.63 17 17-7.63 17-17 17c-2.78 0-5.54-.69-7.99-2a.995.995 0 0 0-.47-.12c-.07 0-.15 0-.22.02l-7.19 1.59 2.85-4.5c.23-.37.2-.84-.07-1.17-2.52-3.04-3.9-6.89-3.9-10.84z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 48.5,
    r: 1.5,
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 33c1.65 0 3 1.35 3 3s-1.35 3-3 3c-.55 0-1 .45-1 1v5h2v-4.1a5 5 0 1 0-6-4.9h2c0-1.65 1.35-3 3-3zM36 16h16v2H36zM36 22h16v2H36zM40 28h12v2H40z",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.53dd18737c3e1a1c30ea5ca7aefeb821.svg";
export { ForwardRef as ReactComponent };